/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FormStatus {
  Draft = "Draft",
  Submitted = "Submitted",
  Returned = "Returned",
  AdmRefusal = "AdmRefusal",
  UnderConsideration = "UnderConsideration",
  PendingDecision = "PendingDecision",
  Decided = "Decided",
  Completed = "Completed",
  UnallocatedMunicipality = "UnallocatedMunicipality",
  UnderConsiderationMunicipality = "UnderConsiderationMunicipality",
  ReturnedByMunicipality = "ReturnedByMunicipality",
  Approved = "Approved",
  Refusal = "Refusal",
  Withdrawn = "Withdrawn",
  Unallocated = "Unallocated",
  MissingInformation = "MissingInformation",
}
